/**
 * @file   聊天对话框
 * @create macaiqi 2025/04/30
 * @update 
 */
import React from 'react';
import talk from "../../assets/images/shade-talk.png";

export default function TalkShade({ setShow }) {
    return (
        <div className="shade   animate__animated animate__fadeIn animate__fast">
            <i
                className="close"
                onClick={() => {
                    setShow();
                }}
            ></i>
            <img src={talk} alt="" />
            <div className="csbtn" onClick={() => {
                setShow('gq');
            }}></div>
            <div
                className="closebtn"
                onClick={() => {
                    setShow('mxq');
                }}
            ></div>
        </div>
    );
}
